import React, { useState } from 'react';
import cn from 'classnames';
import Footer from 'components/Footer/Footer';
import { Link } from "react-router-dom";

import forget_dash_styles from './forgetPassword.module.scss';
import styles from './signin.module.scss';
import dash_styles from '../mychargers.module.scss';
import { Auth } from 'aws-amplify';

async function logIn() {
    try {
        const user = await Auth.signIn("fleetboxstaging@nuvve.com", "@!V^f$hR08!wca@!");
        // const user = await Auth.signIn(username, password);
    } catch (error) {
        console.log('error signing in', error);
    }
}





export default function ForgetPassword(props) {
    const [userData, setUserData] = useState({ userName: '', password: '' });
    const [errorMessage, setErrorMessage] = useState({ value: '' });
    async function addUsername(userName) {
        try {
            // const user = await Auth.signIn("fleetboxstaging@nuvve.com", "@!V^f$hR08!wca@!");
            if (userName === "") {
                setErrorMessage((prevState) => ({
                    value: "Empty username field",
                }));
            } else {
                const user = await Auth.forgotPassword(userName)
                    .then(data => {
                        //success
                        localStorage.setItem('name', userData.userName)
                        localStorage.setItem('isMailSent', true);
                        window.location.pathname = "/newPassword";
                    })
                    .catch(err => setErrorMessage((prevState) => ({ value: "Invalid username" })));
            }

        }
         catch (error) {
            console.log('error signing in', error);
            // //If credentials entered is invalid
            // setErrorMessage((prevState) => ({ value: "Invalid username/password" }));
        }
    }


    const handleInputChange = (e) => {
        setUserData((prevState) => {
            return {
                ...prevState,
                [e.target.name]: e.target.value,
            };
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        addUsername(userData.userName);
        //if username field is empty, return error message

    };

    return (
        <div className={`ldpg ${cn(dash_styles.main, dash_styles.main_layout)}`}>
            <div className={cn(dash_styles.main_flex, forget_dash_styles.main_flex)}>

                <img src={require('assets/logo.png').default} alt="Rectangle 1" className={cn(styles.username_logo_boxl, styles.username_logo_boxl_layout)} />

                <form onSubmit={handleSubmit}>
                    <div className={cn(styles.panel_group, styles.forget_panel_group_layout)}>
                        {errorMessage.value !== '' && (<p className={cn(styles.error)}> {errorMessage.value} </p>)}

                        <div className={cn(styles.username, styles.username_layout)}>
                            <h1>
                                {'Please enter your username/email to continue'}
                            </h1>
                            <input type="text" name="userName" onChange={(e) => handleInputChange(e)} className={cn(styles.forgot_username_box, styles.forgot_username_box_layout)} />
                        </div>

                        <h3 className={cn(styles.return_login_text, styles.return_login_text_layout)}>
                            <Link to="/signin" className={cn(styles.return_login_text2)}>
                                Back to login
                            </Link>
                        </h3>
                        <button type='submit' className={cn(styles.panel_group_big_title3, styles.panel_group_big_title_layout3, styles.panel_group_block, styles.panel_group_block_layout)}>
                        {/* disabled={!userData.userName}  */}
                            {'Next'}
                        </button>
                    </div>
                </form>
                <Footer></Footer>

            </div>
        </div>

    );
}

ForgetPassword.inStorybook = true;
